import DashImg from "../../assets/sidebar/dashboard";
import PageHeader from "../../components/table/pageHeader/PageHeader";
import NoProdImgIcon from "../../assets/products/noProdImg.svg";
import { useEffect, useRef, useState } from "react";
import useList from "../../controller/list-controller";
import TableContainer from "../../components/table/TableContainer";
import { buildColumns } from "../../utils/helper";
import { toast } from "react-toastify";
import Schemes from "../../assets/sidebar/schemes";
import ReactApexChart from "react-apexcharts";
import rgbHex from "rgb-hex";
import Loader from "../../components/Loader";
import Slick from "react-slick";
import PrevImg from "../../assets/prev-icon.js";
import Lightbox from "react-image-lightbox";
import "../account-details/account-details.scss";
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from "react-accessible-accordion";

const hexConverter = (length) => {
  const arr = [];
  for (let i = length; i > 0; i--) {
    // background: rgba(225, 27, 34, 0.8);
    arr.push(`#${rgbHex(225, 27, 34, ((100 / length).toFixed(10) * i) / 100)}`);
  }
  return arr;
};

const formatNumberWithK = (number) => {
  if (number >= 1000) {
    return (number / 1000).toFixed(0) + "k";
  } else {
    return number.toString();
  }
};

const commSlider = {
  slidesToShow: 1,
  slidesToScroll: 1,
  infinite: true,
  dots: false,
  arrows: false,
};

const commPieChart = {
  // value show inside stroke
  dataLabels: {
    enabled: true,
    style: {
      fontSize: window.innerWidth <= 768 ? "10px" : "12px",
      fontWeight: "400",
      colors: ["#000"],
      boxShadow: "none",
    },
    dropShadow: {
      enabled: false,
    },
    formatter: function (val, opt) {
      return [
        opt.w.config.series[opt.seriesIndex].toFixed(2),
        "(" + val.toFixed(2) + "%)",
      ];
    },
  },
  // to show hover value
  tooltip: {
    enabled: false,
  },
  // remove white space between each slice
  stroke: {
    width: 0,
  },
  plotOptions: {
    pie: {
      dataLabels: {
        offset: window.innerWidth <= 768 ? 20 : 30,
      },
      customScale: 0.85,
      expandOnClick: false,
      donut: {
        size: "70%",
        labels: {
          show: true,
          name: {
            show: false,
          },
          value: {
            show: true,
            color: "#000000",
            fontSize: window.innerWidth <= 768 ? "16px" : "22px",
            fontWeight: 600,
          },
          total: {
            show: true,
            showAlways: true,
            formatter: function (w) {
              return w.globals.seriesTotals.reduce((a, b) => {
                return parseFloat((a + b).toFixed(2));
              }, 0);
            },
          },
        },
      },
    },
  },
  // for display color indicator with value
  legend: {
    show: true,
    fontSize: window.innerWidth <= 768 ? "11px" : "16px",
    fontFamily: "inherit",
    fontWeight: 400,
    showForSingleSeries: true,
    position: "right",
    showForNullSeries: true,
    showForZeroSeries: true,
    horizontalAlign: "center",
    floating: false,
    inverseOrder: false,
    // width: undefined,
    // height: undefined,
    tooltipHoverFormatter: undefined,
    customLegendItems: [],
    // offsetX: 50,
    // offsetY: 150,
    labels: {
      colors: undefined,
      useSeriesColors: false,
    },
    markers: {
      width: window.innerWidth <= 768 ? 14 : 20,
      height: window.innerWidth <= 768 ? 14 : 20,
      strokeWidth: 0,
      strokeColor: "#fff",
      fillColors: undefined,
      radius: 4,
      customHTML: undefined,
      onClick: undefined,
      offsetX: 0,
      offsetY: 0,
    },
  },
};

const commBarChart = {
  colors: ["#E11B22"],
  plotOptions: {
    bar: {
      horizontal: true,
      barHeight: "90%",
    },
  },
  dataLabels: {
    enabled: false,
  },
  fill: {
    gradient: {
      shade: "light",
      type: "horizontal",
      shadeIntensity: 0.25,
      gradientToColors: undefined,
      inverseColors: true,
      opacityFrom: 1,
      opacityTo: 1,
      stops: [50, 0, 100, 100],
    },
  },
  xaxis: {
    reversed: true,
    position: "left",
    labels: {
      offsetY: -15,
      offsetX: 6,
      show: true,
      formatter: function (val) {
        return formatNumberWithK(val);
      },
      style: {
        colors: ["#000000"],
        fontFamily: "inherit",
        cssClass: "md:text-lg text-[10px] font-semibold",
      },
    },
    tooltip: {
      enabled: false,
      offsetY: -35,
    },
    axisBorder: {
      show: false,
    },
    axisTicks: {
      show: false,
    },
  },
  yaxis: {
    title: {
      text: "FMI Product",
      style: {
        color: "rgb(113, 113, 113)",
        fontSize: "16px",
        fontFamily: "inherit",
        fontWeight: 400,
      },
    },
    labels: {
      show: true,
      maxWidth: window.innerWidth <= 768 ? 130 : 230,
      style: {
        fontFamily: "inherit",
        cssClass: "md:text-xs text-[10px] font-normal",
      },
    },
    axisBorder: {
      show: false,
    },
    axisTicks: {
      show: false,
    },
  },
  chart: {
    animations: {
      enabled: false,
    },
    toolbar: {
      show: false,
    },
  },
  tooltip: {
    enabled: false,
  },
  grid: {
    show: true,
    borderColor: "#DADADA",
    strokeDashArray: 0,
    position: "back",
    xaxis: {
      lines: {
        show: true,
      },
    },
    yaxis: {
      lines: {
        show: false,
      },
    },
    row: {
      colors: undefined,
      opacity: 0.5,
    },
    column: {
      colors: undefined,
      opacity: 0.5,
    },
    padding: {
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
    },
  },
};

export default function Dashboard() {
  const { getDashboardData, dashboardData, isLoading, errMsg } = useList();
  const sliderRef = useRef();
  const sliderRef2 = useRef();
  const [isLoader, setIsLoader] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [currentSlide2, setCurrentSlide2] = useState(0);
  const [isOpenImgLightBox, setIsOpenImgLightBox] = useState(false);
  const [isOpenImgLightBox2, setIsOpenImgLightBox2] = useState(false);
  const [photoIndex, setPhotoIndex] = useState(0);
  const [photoIndex2, setPhotoIndex2] = useState(0);

  const setting = {
    ...commSlider,
    afterChange: (current) => setCurrentSlide(current),
  };

  const setting2 = {
    ...commSlider,
    afterChange: (current) => setCurrentSlide2(current),
  };

  const totalOverduePaymentOptions = {
    labels: dashboardData?.totalOverduePayment?.label
      ? [dashboardData?.totalOverduePayment?.label]
      : [],
    colors: ["#E11B22"],
    // value show inside stroke
    dataLabels: {
      enabled: false,
    },
    // to show hover value
    tooltip: {
      enabled: false,
    },
    // remove white space between each slice
    stroke: {
      width: 0,
    },
    plotOptions: {
      pie: {
        donut: {
          size: "70%",
          labels: {
            show: true,
            name: {
              show: false,
            },
            value: {
              show: true,
              color: "#000000",
              fontSize: "22px",
              fontWeight: 600,
            },
            total: {
              show: true,
              showAlways: true,
            },
          },
        },
      },
    },
    // for display color indicator with value
    legend: {
      show: false,
    },
  };

  const thisWeekLudhianaOrderOptions = {
    ...commPieChart,
    // chart: {
    //   width: isMobile ? "310" : "400",
    // },
    labels: dashboardData?.thisWeekLudhianaOrder
      ? Object.keys(dashboardData?.thisWeekLudhianaOrder)?.map((dt) =>
          isMobile ? `${dt?.substr(0, 13)}${dt?.length > 13 ? `..` : ""}` : dt
        )
      : [],
    colors: dashboardData?.thisWeekLudhianaOrder
      ? hexConverter(Object.keys(dashboardData?.thisWeekLudhianaOrder).length)
      : [],
  };

  const thisWeekGurgaonOrderOptions = {
    ...commPieChart,
    // chart: {
    //   width: isMobile ? "310" : "400",
    // },
    labels: dashboardData?.thisWeekGurgaonOrder
      ? Object.keys(dashboardData?.thisWeekGurgaonOrder)?.map((dt) =>
          isMobile ? `${dt?.substr(0, 13)}${dt?.length > 13 ? `..` : ""}` : dt
        )
      : [],
    colors: dashboardData?.thisWeekGurgaonOrder
      ? hexConverter(Object.keys(dashboardData?.thisWeekGurgaonOrder).length)
      : [],
  };

  const thisMonthSchemeProductOptions = {
    ...commBarChart,
    xaxis: {
      ...commBarChart.xaxis,
      categories: dashboardData?.thisMonthSchemeProduct
        ? Object.keys(dashboardData?.thisMonthSchemeProduct)
        : [],
    },
    yaxis: {
      ...commBarChart.yaxis,
      labels: {
        ...commBarChart.yaxis.labels,
        style: {
          ...commBarChart.yaxis.labels.style,
          colors: dashboardData?.thisMonthSchemeProduct
            ? Object.keys(dashboardData?.thisMonthSchemeProduct)?.map(
                () => "#000000"
              )
            : [],
        },
      },
    },
  };

  const thisMonthFocusProductOptions = {
    ...commBarChart,
    xaxis: {
      ...commBarChart.xaxis,
      categories: dashboardData?.thisMonthFocusProduct
        ? Object.keys(dashboardData?.thisMonthFocusProduct)
        : [],
    },
    yaxis: {
      ...commBarChart.yaxis,
      labels: {
        ...commBarChart.yaxis.labels,
        style: {
          ...commBarChart.yaxis.labels.style,
          colors: dashboardData?.thisMonthFocusProduct
            ? Object.keys(dashboardData?.thisMonthFocusProduct)?.map(
                () => "#000000"
              )
            : [],
        },
      },
    },
  };

  const overduePaymentTop5CustomerOptions = {
    ...commPieChart,
    // chart: {
    //   width: isMobile ? "310" : "400",
    // },
    labels: dashboardData?.overduePaymentTop5Customer
      ? Object.keys(dashboardData?.overduePaymentTop5Customer)?.map((dt) =>
          isMobile ? `${dt?.substr(0, 13)}${dt?.length > 13 ? `..` : ""}` : dt
        )
      : [],
    colors: dashboardData?.overduePaymentTop5Customer
      ? hexConverter(
          Object.keys(dashboardData?.overduePaymentTop5Customer).length
        )
      : [],
  };

  useEffect(() => {
    getDashboardData();
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    setIsLoader(isLoading);
  }, [isLoading]);

  useEffect(() => {
    if (errMsg) {
      toast.error(errMsg);
    }
  }, [errMsg]);

  const handleResize = () => {
    setIsMobile(window.innerWidth <= 768);
  };

  return (
    <div
      className={`accounts-container h-full flex flex-col mt-2 md:static overflow-y-auto relative ${
        isLoader ? "mt-2 -mt-[70px]" : ""
      }`}
      id="scroll-div"
    >
      {isLoader ? (
        <div className="flex md:h-full h-[calc(100%_-_100px)] justify-center align-center">
          <Loader />
        </div>
      ) : (
        <>
          <PageHeader
            svg={<DashImg color="white" width={24} height={24} />}
            text={"Dashboard"}
            subTitle={"Highlights & Summaries"}
          />
          {isOpenImgLightBox && (
            <Lightbox
              mainSrc={dashboardData?.newProducts?.images[photoIndex]}
              nextSrc={
                dashboardData?.newProducts?.images[
                  (photoIndex + 1) % dashboardData?.newProducts?.images.length
                ]
              }
              prevSrc={
                dashboardData?.newProducts?.images[
                  (photoIndex + dashboardData?.newProducts?.images.length - 1) %
                    dashboardData?.newProducts?.images.length
                ]
              }
              onCloseRequest={() => setIsOpenImgLightBox(false)}
              onMovePrevRequest={() =>
                setPhotoIndex(
                  (photoIndex + dashboardData?.newProducts?.images.length - 1) %
                    dashboardData?.newProducts?.images.length
                )
              }
              onMoveNextRequest={() =>
                setPhotoIndex(
                  (photoIndex + 1) % dashboardData?.newProducts?.images.length
                )
              }
            />
          )}
          {isOpenImgLightBox2 && (
            <Lightbox
              mainSrc={dashboardData?.upcomingExhibition?.images[photoIndex2]}
              nextSrc={
                dashboardData?.upcomingExhibition?.images[
                  (photoIndex2 + 1) %
                    dashboardData?.upcomingExhibition?.images.length
                ]
              }
              prevSrc={
                dashboardData?.upcomingExhibition?.images[
                  (photoIndex2 +
                    dashboardData?.upcomingExhibition?.images.length -
                    1) %
                    dashboardData?.upcomingExhibition?.images.length
                ]
              }
              onCloseRequest={() => setIsOpenImgLightBox2(false)}
              onMovePrevRequest={() =>
                setPhotoIndex2(
                  (photoIndex2 +
                    dashboardData?.upcomingExhibition?.images.length -
                    1) %
                    dashboardData?.upcomingExhibition?.images.length
                )
              }
              onMoveNextRequest={() =>
                setPhotoIndex2(
                  (photoIndex2 + 1) %
                    dashboardData?.upcomingExhibition?.images.length
                )
              }
            />
          )}
          <div>
            <div className="accordianWrapper">
              <Accordion
                allowMultipleExpanded={true}
                allowZeroExpanded={true}
                preExpanded={["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"]}
              >
                <div className="md:grid md:grid-cols-2">
                  <AccordionItem
                    uuid={"0"}
                    className="accItem mb-4 md:mr-4"
                    dangerouslySetExpanded={true}
                  >
                    <AccordionItemHeading>
                      <AccordionItemButton
                        className={`bg-white-200 accButton py-4 px-4 flex flex-row justify-between items-center md:rounded-t-lg`}
                      >
                        <div className="flex flex-row font-semibold md:text-[22px] text-base accTitle">
                          <span className="mr-2">
                            <Schemes color={"#e11b22"} width="25" height="25" />
                          </span>
                          New Product
                        </div>
                      </AccordionItemButton>
                    </AccordionItemHeading>
                    <AccordionItemPanel>
                      <div className="bg-white-100 accPanel md:rounded-b-lg py-5 px-4 md:h-[480px] h-[450px]">
                        {dashboardData?.newProducts?.images?.length > 0 ? (
                          <>
                            <div className="slickWrapper md:h-[380px] h-[350px]">
                              <Slick ref={sliderRef} {...setting}>
                                {dashboardData?.newProducts?.images.map(
                                  (dt, i) => {
                                    return (
                                      <div
                                        className="img relative cursor-pointer bg-white-200 border-2 w-full h-full"
                                        onClick={() =>
                                          setIsOpenImgLightBox(true)
                                        }
                                        key={i}
                                      >
                                        <img src={dt} alt="product" />
                                        <div className="viewBtn">
                                          <button>View</button>
                                        </div>
                                      </div>
                                    );
                                  }
                                )}
                              </Slick>
                            </div>
                            <div className="flex justify-center mt-7">
                              <div
                                onClick={() => sliderRef.current.slickPrev()}
                                className="prevButton cursor-pointer md:rounded-lg	flex items-center justify-center"
                              >
                                <PrevImg />
                              </div>
                              <div className="slideNum md:rounded-lg	flex items-center justify-center mx-1.5 py-1.5 px-4">
                                {currentSlide + 1} /{" "}
                                {dashboardData?.newProducts?.images?.length}
                              </div>
                              <div
                                onClick={() => sliderRef.current.slickNext()}
                                className="nextButton cursor-pointer md:rounded-lg	rotate-180 flex items-center justify-center"
                              >
                                <PrevImg />
                              </div>
                            </div>
                          </>
                        ) : (
                          <div className="flex flex-col items-center justify-center h-full">
                            <div>
                              <img
                                width={100}
                                height={100}
                                src={NoProdImgIcon}
                                alt="infoImg"
                                className="mb-5"
                              />
                            </div>
                            <p className="font-semibold	text-sm mt-2">
                              No Product Image Found
                            </p>
                          </div>
                        )}
                      </div>
                    </AccordionItemPanel>
                  </AccordionItem>

                  <AccordionItem
                    uuid={"1"}
                    className="accItem mb-4"
                    dangerouslySetExpanded={true}
                  >
                    <AccordionItemHeading>
                      <AccordionItemButton
                        className={`bg-white-200 accButton py-4 px-4 flex flex-row justify-between items-center md:rounded-t-lg`}
                      >
                        <div className="flex flex-row font-semibold md:text-[22px] text-base accTitle">
                          <span className="mr-2">
                            <Schemes color={"#e11b22"} width="25" height="25" />
                          </span>
                          Exhibitions
                        </div>
                      </AccordionItemButton>
                    </AccordionItemHeading>
                    <AccordionItemPanel>
                      <div className="bg-white-100 accPanel md:rounded-b-lg py-5 px-4 md:h-[480px] h-[450px]">
                        {dashboardData?.upcomingExhibition?.images?.length >
                        0 ? (
                          <>
                            <div className="slickWrapper md:h-[380px] h-[350px]">
                              <Slick ref={sliderRef2} {...setting2}>
                                {dashboardData?.upcomingExhibition?.images.map(
                                  (dt, i) => {
                                    return (
                                      <div
                                        className="img relative cursor-pointer bg-white-200 border-2 w-full h-full"
                                        onClick={() =>
                                          setIsOpenImgLightBox2(true)
                                        }
                                        key={i}
                                      >
                                        <img src={dt} alt="product" />
                                        <div className="viewBtn">
                                          <button>View</button>
                                        </div>
                                      </div>
                                    );
                                  }
                                )}
                              </Slick>
                            </div>
                            <div className="flex justify-center mt-7">
                              <div
                                onClick={() => sliderRef2.current.slickPrev()}
                                className="prevButton cursor-pointer md:rounded-lg	flex items-center justify-center"
                              >
                                <PrevImg />
                              </div>
                              <div className="slideNum md:rounded-lg	flex items-center justify-center mx-1.5 py-1.5 px-4">
                                {currentSlide2 + 1} /{" "}
                                {
                                  dashboardData?.upcomingExhibition?.images
                                    ?.length
                                }
                              </div>
                              <div
                                onClick={() => sliderRef2.current.slickNext()}
                                className="nextButton cursor-pointer md:rounded-lg	rotate-180 flex items-center justify-center"
                              >
                                <PrevImg />
                              </div>
                            </div>
                          </>
                        ) : (
                          <div className="flex flex-col items-center justify-center h-full">
                            <div>
                              <img
                                width={100}
                                height={100}
                                src={NoProdImgIcon}
                                alt="infoImg"
                                className="mb-5"
                              />
                            </div>
                            <p className="font-semibold	text-sm mt-2">
                              No Product Image Found
                            </p>
                          </div>
                        )}
                      </div>
                    </AccordionItemPanel>
                  </AccordionItem>
                </div>
                <div className="md:grid md:grid-cols-2">
                  <AccordionItem
                    uuid={"4"}
                    className="accItem mb-4 md:mr-4"
                    dangerouslySetExpanded={true}
                  >
                    <AccordionItemHeading>
                      <AccordionItemButton
                        className={`bg-white-200 accButton py-4 px-4 flex flex-row justify-between items-center md:rounded-t-lg`}
                      >
                        <div className="flex flex-row font-semibold md:text-[22px] text-base accTitle">
                          This Week’s Order Value (Gurugram Unit)
                        </div>
                      </AccordionItemButton>
                    </AccordionItemHeading>
                    <AccordionItemPanel>
                      <div className="bg-white-100 accPanel md:rounded-b-lg py-5 px-4 md:h-[300px] h-[250px]">
                        <div className="md:h-[222px] h-[170px] donut-chart">
                          {dashboardData?.thisWeekGurgaonOrder &&
                          Object.keys(dashboardData?.thisWeekGurgaonOrder)
                            .length > 0 ? (
                            <ReactApexChart
                              options={thisWeekGurgaonOrderOptions}
                              series={
                                dashboardData?.thisWeekGurgaonOrder
                                  ? Object.values(
                                      dashboardData?.thisWeekGurgaonOrder
                                    )
                                  : []
                              }
                              className="apex-charts"
                              type="donut"
                              height={isMobile ? 170 : 220}
                            />
                          ) : (
                            <div className="flex flex-row items-center justify-center h-[220px] accTitle">
                              No Record Found
                            </div>
                          )}
                        </div>
                        <div className="mt-5 accTitle text-center">
                          Sum of Grand Total (Gurgaon) (INR)
                        </div>
                      </div>
                    </AccordionItemPanel>
                  </AccordionItem>

                  <AccordionItem
                    uuid={"3"}
                    className="accItem mb-4"
                    dangerouslySetExpanded={true}
                  >
                    <AccordionItemHeading>
                      <AccordionItemButton
                        className={`bg-white-200 accButton py-4 px-4 flex flex-row justify-between items-center md:rounded-t-lg`}
                      >
                        <div className="flex flex-row font-semibold md:text-[22px] text-base accTitle">
                          This Week’s Order Value (Doraha Unit)
                        </div>
                      </AccordionItemButton>
                    </AccordionItemHeading>
                    <AccordionItemPanel>
                      <div className="bg-white-100 accPanel md:rounded-b-lg py-5 px-4 md:h-[300px] h-[250px]">
                        <div className="md:h-[222px] h-[170px] donut-chart">
                          {dashboardData?.thisWeekLudhianaOrder &&
                          Object.keys(dashboardData?.thisWeekLudhianaOrder)
                            .length > 0 ? (
                            <ReactApexChart
                              options={thisWeekLudhianaOrderOptions}
                              series={
                                dashboardData?.thisWeekLudhianaOrder
                                  ? Object.values(
                                      dashboardData?.thisWeekLudhianaOrder
                                    )
                                  : []
                              }
                              className="apex-charts"
                              type="donut"
                              height={isMobile ? 170 : 220}
                            />
                          ) : (
                            <div className="flex flex-row items-center justify-center h-[220px] accTitle">
                              No Record Found
                            </div>
                          )}
                        </div>
                        <div className="mt-5 accTitle text-center">
                          Sum of Grand Total (Ludhiana) (INR)
                        </div>
                      </div>
                    </AccordionItemPanel>
                  </AccordionItem>
                </div>
                <div className="md:grid md:grid-cols-2">
                  <AccordionItem
                    uuid={"2"}
                    className="accItem mb-4 md:mr-4"
                    dangerouslySetExpanded={true}
                  >
                    <AccordionItemHeading>
                      <AccordionItemButton
                        className={`bg-white-200 accButton py-4 px-4 flex flex-row justify-between items-center md:rounded-t-lg`}
                      >
                        <div className="flex flex-row font-semibold md:text-[22px] text-base accTitle">
                          Total Overdue Payments
                        </div>
                      </AccordionItemButton>
                    </AccordionItemHeading>
                    <AccordionItemPanel>
                      <div className="bg-white-100 accPanel md:rounded-b-lg py-5 px-4 md:h-[300px] h-[250px]">
                        <div className="md:h-[222px] h-[170px] donut-chart">
                          {dashboardData?.totalOverduePayment &&
                          Object.keys(dashboardData?.totalOverduePayment)
                            .length > 0 ? (
                            <ReactApexChart
                              options={totalOverduePaymentOptions}
                              series={[
                                dashboardData?.totalOverduePayment?.value || 0,
                              ]}
                              className="apex-charts"
                              type="donut"
                              height={isMobile ? 170 : 220}
                            />
                          ) : (
                            <div className="flex flex-row items-center justify-center h-[220px] accTitle">
                              No Record Found
                            </div>
                          )}
                        </div>
                        <div className="mt-5 accTitle text-center">
                          Total Payments (INR)
                        </div>
                      </div>
                    </AccordionItemPanel>
                  </AccordionItem>

                  <AccordionItem
                    uuid={"9"}
                    className="accItem mb-4"
                    dangerouslySetExpanded={true}
                  >
                    <AccordionItemHeading>
                      <AccordionItemButton
                        className={`bg-white-200 accButton py-4 px-4 flex flex-row justify-between items-center md:rounded-t-lg`}
                      >
                        <div className="flex flex-row font-semibold md:text-[22px] text-base accTitle">
                          Overdue Payments Top 5 Customers
                        </div>
                      </AccordionItemButton>
                    </AccordionItemHeading>
                    <AccordionItemPanel>
                      <div className="bg-white-100 accPanel md:rounded-b-lg py-5 px-4 md:h-[300px] h-[250px]">
                        <div className="md:h-[222px] h-[170px] donut-chart">
                          {dashboardData?.overduePaymentTop5Customer &&
                          Object.keys(dashboardData?.overduePaymentTop5Customer)
                            .length > 0 ? (
                            <ReactApexChart
                              options={overduePaymentTop5CustomerOptions}
                              series={
                                dashboardData?.overduePaymentTop5Customer
                                  ? Object.values(
                                      dashboardData?.overduePaymentTop5Customer
                                    )
                                  : []
                              }
                              className="apex-charts"
                              type="donut"
                              height={isMobile ? 170 : 220}
                            />
                          ) : (
                            <div className="flex flex-row items-center justify-center h-[220px] accTitle">
                              No Record Found
                            </div>
                          )}
                        </div>
                        <div className="mt-5 accTitle text-center">
                          Sum of Overdue Payments (INR)
                        </div>
                      </div>
                    </AccordionItemPanel>
                  </AccordionItem>
                </div>
                <div className="md:grid md:grid-cols-2">
                  <AccordionItem
                    uuid={"5"}
                    className="accItem mb-4 md:mr-4"
                    dangerouslySetExpanded={true}
                  >
                    <AccordionItemHeading>
                      <AccordionItemButton
                        className={`bg-white-200 accButton py-4 px-4 flex flex-row justify-between items-center md:rounded-t-lg`}
                      >
                        <div className="flex flex-row font-semibold md:text-[22px] text-base accTitle">
                          This Month Scheme Products (Quantity)
                        </div>
                      </AccordionItemButton>
                    </AccordionItemHeading>
                    <AccordionItemPanel>
                      <div className="bg-white-100 accPanel md:rounded-b-lg py-5 px-4">
                        <div className="flex flex-col">
                          {dashboardData?.thisMonthSchemeProduct &&
                          Object.keys(dashboardData?.thisMonthSchemeProduct)
                            ?.length > 0 ? (
                            <ReactApexChart
                              options={thisMonthSchemeProductOptions}
                              series={[
                                {
                                  data: dashboardData?.thisMonthSchemeProduct
                                    ? Object.values(
                                        dashboardData?.thisMonthSchemeProduct
                                      )
                                    : [],
                                },
                              ]}
                              className="apex-charts"
                              type="bar"
                              height={300}
                            />
                          ) : (
                            <div className="flex flex-row items-center justify-center md:h-[315px] h-[220px] accTitle">
                              No Record Found
                            </div>
                          )}
                          <div className="accTitle text-center">
                            Sum of Quantity
                          </div>
                        </div>
                      </div>
                    </AccordionItemPanel>
                  </AccordionItem>

                  <AccordionItem
                    uuid={"6"}
                    className="accItem mb-4"
                    dangerouslySetExpanded={true}
                  >
                    <AccordionItemHeading>
                      <AccordionItemButton
                        className={`bg-white-200 accButton py-4 px-4 flex flex-row justify-between items-center md:rounded-t-lg`}
                      >
                        <div className="flex flex-row font-semibold md:text-[22px] text-base accTitle">
                          This Month Focus Products (Quantity)
                        </div>
                      </AccordionItemButton>
                    </AccordionItemHeading>
                    <AccordionItemPanel>
                      <div className="bg-white-100 accPanel md:rounded-b-lg py-5 px-4">
                        <div className="flex flex-col">
                          {dashboardData?.thisMonthFocusProduct &&
                          Object.keys(dashboardData?.thisMonthFocusProduct)
                            ?.length > 0 ? (
                            <ReactApexChart
                              options={thisMonthFocusProductOptions}
                              series={[
                                {
                                  data: dashboardData?.thisMonthFocusProduct
                                    ? Object.values(
                                        dashboardData?.thisMonthFocusProduct
                                      )
                                    : [],
                                },
                              ]}
                              className="apex-charts"
                              type="bar"
                              height={300}
                            />
                          ) : (
                            <div className="flex flex-row items-center justify-center md:h-[315px] h-[220px] accTitle">
                              No Record Found
                            </div>
                          )}
                          <div className="accTitle text-center">
                            Sum of Quantity
                          </div>
                        </div>
                      </div>
                    </AccordionItemPanel>
                  </AccordionItem>
                </div>
                <div className="md:grid md:grid-cols-1">
                  <AccordionItem
                    uuid={"7"}
                    className="accItem mb-4"
                    dangerouslySetExpanded={true}
                  >
                    <AccordionItemHeading>
                      <AccordionItemButton
                        className={`bg-white-200 accButton py-4 px-4 flex flex-row justify-between items-center md:rounded-t-lg`}
                      >
                        <div className="flex flex-row font-semibold md:text-[22px] text-base accTitle">
                          Schemes
                        </div>
                      </AccordionItemButton>
                    </AccordionItemHeading>
                    <AccordionItemPanel>
                      <div className="bg-white-100 accPanel md:rounded-b-lg pt-5">
                        {buildColumns(
                          dashboardData?.thisMonthScheme?.fields
                        ) ? (
                          <div className="overflow-hidden h-[300px]">
                            <TableContainer
                              data={dashboardData?.thisMonthScheme?.records}
                              columns={buildColumns(
                                dashboardData?.thisMonthScheme?.fields
                              )?.filter((col) => {
                                return col?.fieldLabel;
                              })}
                              rowClick={() => {}}
                              gotoPage={() => {}}
                              pageIndex={0}
                              isLoading={isLoading}
                              pageCount={0}
                              setOrderCol={() => {}}
                              setOrderType={() => {}}
                              fullHeigth={false}
                            />
                          </div>
                        ) : (
                          <div className="flex flex-row items-center justify-center h-[100px] accTitle">
                            No Record Found
                          </div>
                        )}
                      </div>
                    </AccordionItemPanel>
                  </AccordionItem>
                </div>
                <div className="md:grid md:grid-cols-1">
                  <AccordionItem
                    uuid={"8"}
                    className="accItem mb-4"
                    dangerouslySetExpanded={true}
                  >
                    <AccordionItemHeading>
                      <AccordionItemButton
                        className={`bg-white-200 accButton py-4 px-4 flex flex-row justify-between items-center md:rounded-t-lg`}
                      >
                        <div className="flex flex-row font-semibold md:text-[22px] text-base accTitle">
                          Birthday Boy Scheme Orders
                        </div>
                      </AccordionItemButton>
                    </AccordionItemHeading>
                    <AccordionItemPanel>
                      <div className="bg-white-100 accPanel md:rounded-b-lg pt-5">
                        {buildColumns(
                          dashboardData?.birthdayBoyScheme?.fields
                        ) ? (
                          <div className="overflow-hidden h-[300px]">
                            <TableContainer
                              data={dashboardData?.birthdayBoyScheme?.records}
                              columns={buildColumns(
                                dashboardData?.birthdayBoyScheme?.fields
                              )?.filter((col) => {
                                return col?.fieldLabel;
                              })}
                              rowClick={() => {}}
                              gotoPage={() => {}}
                              pageIndex={0}
                              isLoading={isLoading}
                              pageCount={0}
                              setOrderCol={() => {}}
                              setOrderType={() => {}}
                              fullHeigth={false}
                            />
                          </div>
                        ) : (
                          <div className="flex flex-row items-center justify-center h-[100px] accTitle">
                            No Record Found
                          </div>
                        )}
                      </div>
                    </AccordionItemPanel>
                  </AccordionItem>
                </div>
              </Accordion>
            </div>
          </div>
        </>
      )}
    </div>
  );
}
